import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { WELCOME, REGISTRATION, SUMMARY } = USA.CONTENT

const partnerName = 'Fidelis Care of New York'

const fidelisCareNewYork: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    name: partnerName,
    id: 'fidelis-care',
    productConfigAppName: 'fidelis-care',
    codes: {
      membership: 'Fidelis',
    },
    partnerUrlSlug: 'fidelis',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: [
            'Get healthcare anytime from your phone. At no cost through Fidelis Care Qualified Health Plans. Data rates may apply.',
          ],
        },
        REGISTRATION.enUS,
        SUMMARY.enUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
    'es-US': {
      steps: [
        {
          ...WELCOME.esUS,
          copy: [
            'Obtenga atención médica en cualquier momento desde su teléfono. Sin costo para usted a través de los planes de atención médica calificados de Fidelis Care. Pueden aplicarse tarifas de datos.',
          ],
        },
        REGISTRATION.esUS,
        SUMMARY.esUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const fidelisCareNewYorkWithDnaV2Design: PartnerConfig = {
  ...fidelisCareNewYork,
  branding: {
    logo: [
      LOGOS.BABYLON,
      {
        src: '/images/USA/Fidelis/new-york.png',
        alt: `${partnerName} logo`,
      },
    ],
  },
  config: {
    ...fidelisCareNewYork.config,
    useDnaV2Design: true,
  },
}

export default [fidelisCareNewYork, fidelisCareNewYorkWithDnaV2Design]
